import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VLayout,{attrs:{"justify-center":"","wrap":""}},[_c(VFlex,{attrs:{"md12":""}},[_c('app-table',{ref:"estimateTable",attrs:{"config":_vm.config,"api-getlist":_vm.getList,"hide-upsert":""},on:{"clone":_vm.clone}},[_c('template',{slot:"headerActions"},[_c(VBtn,{attrs:{"color":"pink","to":"/estimate"}},[_c(VIcon,[_vm._v("mdi-plus")])],1)],1)],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }